import React from "react";
import "./digiservice.css";

const Digiservice = () => {
  return (
    <div className="digiservice-process-div">
      <div className="digiservice-toWhom-text">
        <h1>
          1. Our SEO Services Can Help You Realize the Complete Potential of
          Your Website!
        </h1>
        <br />
        <h2>
          A good online presence is important for success in today's business
          world. Search Engine Optimization (SEO) is the key to not only
          improving exposure of your website thereby resulting in high search
          engine rankings, but also increasing organic traffic along with
          attracting the right kind of traffic. We shall:
        </h2>
        <div className="digitoWhom-points">
          <p>Offer free SEO Audit</p>
          <p>Analyze your competition to stay ahead in the digital race </p>
          <p>
            Advise ranging from content and keyword optimization to user
            experience enhancement
          </p>
          <p>Technical SEO</p>
          <p>On-page SEO and Off-page SEO</p>
          <p>Mobile compatibility</p>
        </div>
      </div>
      <div className="digiservice-toWhom-text">
        <h1>
          2. Local SEO Services: Rise to the Top of Local Search Results and
          Boost Conversion Rate!
        </h1>
        <br />
        <h2>
          Research indicates that 88% of buyers look for internet reviews before
          deciding to choose a local service. Therefore, local SEO is of
          paramount importance to success of a local business.
        </h2>
        <div className="digitoWhom-points">
          <p>Critically assess your Google My Business (GMB) listing</p>
          <p>
            Ascertain your Name, Address & Phone Number (NAP) visibility and
            build local citations
          </p>
          <p>
            Manage your online reviews through an efficient online review
            acquisition approach
          </p>
          <p>Benchmark you against your competitors</p>
          <p>Analyze organic links and penalties, if any</p>
          <p>
            Research on keywords to find industry-specific and
            geography-specific keywords
          </p>
          <p>
            Create a local SEO guide to assist you in curating
            attention-grabbing content
          </p>
          <p>Track your ranking on GMB through periodic reports</p>
          <p>
            Optimizing your homepage and metadata with geographic-specific
            keywords
          </p>
          <p>
            Set up social media signals and add local business schema to your
            website pages
          </p>
          <p>Produce landing pages for local SEO</p>
          <p>
            Include information about your company in general-purpose as well as
            specialist local directories
          </p>
        </div>
      </div>
      <div className="digiservice-toWhom-text">
        <h1>3. Social Media Marketing</h1>
        <br />
        <h2>
          Welcome to Business Guru, your one-stop shop for cutting-edge Social
          Media Marketing services. Our expert team is dedicated to elevating
          your brand to new heights through impactful social media strategies.
        </h2>

        <h2>
          Our tailored Social Media Marketing services are designed to enhance
          your brand visibility, engage your target audience, and drive
          measurable results. From compelling content creation to data-driven
          analytics, we offer a comprehensive suite of solutions that cater to
          your unique business needs.
        </h2>

        <h2>
          Discover the potential of social media with Business Guru - where
          innovation meets influence, and your success is our priority. Let's
          shape your digital narrative together!
        </h2>
      </div>
      <div className="digiservice-toWhom-text">
        <h1>4. Google Ads Services</h1>
        <br />
        <h2>
          As a leading Google Ads Agency, we take pride in driving businesses to
          the forefront of success. At Business Guru, we understand the dynamics
          of digital advertising, and our expert team is dedicated to crafting
          targeted and captivating ROI-driven campaigns which elevate your brand
          visibility and drive conversions.
        </h2>

        <h2>
          Our user-friendly approach ensures that whether you're a startup or an
          established enterprise, navigating the world of Google Ads becomes a
          seamless experience. Discover the Business Guru Advantage today!
        </h2>
      </div>
    </div>
  );
};

export default Digiservice;
